export enum ContextAwareSidebarType {
    LISTING = 'listing',
    OUTLET = 'outlet',
    ROOM = 'room',
    BULK = 'bulk',
}

export enum CustomNavigationTarget {
    OUTLET = 'OUTLET',
    ROOM = 'ROOM',
}

export interface ContextAwareSidebarItem {
    id: string;
    translationKey: string;
    fieldName: string | null;
    icon: string | null;
    customNavigationTarget: CustomNavigationTarget | null;
    order: number;
    featureDetailId: string | null;
    totalChildrenCount?: number;
    children: ContextAwareSidebarItem[];
}

export interface ChildItemViewModel extends ContextAwareSidebarItem {
    isHighlighted: boolean;
    routerLinkSegments: (string | null)[];
}

export interface ItemViewModel extends ContextAwareSidebarItem {
    isExpanded: boolean;
    isActive: boolean;
    isHighlighted: boolean;
    visibleChildren: ChildItemViewModel[];
    hiddenChildrenCount: number;
    showMoreRouterLinkSegments: (string | null)[] | null;
}

export interface ChannelBannerBadge {
    type: 'stale' | 'newSnapshot';
    labelKey: string;
    tooltipKey: string;
    clickable: boolean;
}

export interface BannerViewModel {
    mode: 'version' | 'channel';
    explainerText: string;
    badges: ChannelBannerBadge[];
}
